/**
 * Order Online Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

/* global jQuery, Cookies, google, GOOGLE_API_KEY, GOOGLE_API_KEY_UNFILTERED */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {},
        $form = null,
        $locDisplay = null,
        $mapDisplay = null,
        $loadMore = null,
        searchType = null,
        userAddress = {
            address:null,
            zip:null,
            state:null              // User does not supply state - we try to acquire from geo results
        },
        userCoords = {
            lat:null,
            lng:null
        },
        displayedTakeoutCount = 0,      // Track how many takeout locations are currently being displayed
        displayedTakeoutElements = [],  // Collection of data elements containing marker and dom references for displayed stores
        orderedTakeoutList = [],        // Collection of stores from takeout search, in order from closest to farthest
        DELIVERY = 'delivery',          // Constants to track state of page
        TAKEOUT = 'takeout',
        DISTANCE_RANGES = [5,15,50],
        MAP_ID = 'gMap',
        $content = null;


    // ---------------------------------------------------------
    // FORM
    // ---------------------------------------------------------

    function initForm() {
        var option = null;
        $form = $('#order-search');
        $locDisplay = $('#locations-display');
        $mapDisplay = $('#' + MAP_ID);
        $loadMore = $('#load-more-locations');

        // Select the radio button that matches the page route (as determined by
        // the class on the body)
        if ($('body').hasClass('delivery')) {
            $form.find('.order-search__radio[value=delivery]').prop('checked', true);
        } else {
            $form.find('.order-search__radio[value=takeout]').prop('checked', true);
        }

        // If we have cookied address info, let's add it in
        var address = Cookies.get('address'),
            zip = Cookies.get('zip');
        if (address !== undefined) {
            $form.find('input[name=address]').val(address);
        }
        if (zip !== undefined) {
            $form.find('input[name=zip]').val(zip);
        }
        
        // Let's listen for a toggling of the radio buttons.  If the type of
        // search is changed, we'll want to clear out the location results.
        // Let's also run a search, if the address field is not empty.
        $form.find('.order-search__radio').click(function() {
            // NOTE: we also want to hide/show the full list of stores for
            // TAKEOUT, depending on which radio button was selected.
            if ($(this).val() == 'takeout') {
                // $('.order-online__full-list').removeClass('is-hidden');
                $('.order-online__full-list').hide().removeClass('is-hidden').fadeIn();
            } else {
                // $('.order-online__full-list').addClass('is-hidden');
                $('.order-online__full-list').fadeOut();
            }

            // clearResults();
            submitForm(true);
        });

        // Set up our form submit callback
        $form.submit(function(evt){
            submitForm(false);
            return false;
        });

        // Set up our 'load more' button callback
        $loadMore.click(function(evt) {
            evt.preventDefault();
            updateTakeoutDisplay();
            renderTakeoutMap();
        });
    }

    /**
     * Here, we manage the submission of the search form.  Note that we also
     * attempt a form submission when the user toggles between Delivery and
     * Takeout -- when this occurs, we want to suppress the display of 
     * error information (ie. messaging that indicates missing fields), 
     * as it may not have been the users' intent to submit the form just
     * yet.
     * @param  {boolean} suppressFeedback Whether or not to show error feedback on incomplete form
     * @return {void}                  
     */
    function submitForm(suppressFeedback) {
        clearResults();     // Clear out any existing locations or messaging
        processSearch(suppressFeedback);
    }

    function activateForm() {
        $form.find('.order-search__submit-unit').removeClass('disabled');
        $form.find('input[type=submit]').prop('disabled', false);
    }

    function deactivateForm() {
        $form.find('.order-search__submit-unit').addClass('disabled');
        $form.find('input[type=submit]').prop('disabled', true);
    }


    // ---------------------------------------------------------
    // SEARCH
    // ---------------------------------------------------------
    
    /**
     * Called when search form is initially submitted.  We need to first
     * run a geocode search (getUserCoords) before proceeding with the
     * actual location of relevant stores.
     * @return {void} 
     */
    function processSearch(suppressFeedback) {
        deactivateForm();
        // Store our search type (will process once geo-lookup is complete)
        searchType = $form.find('.order-search__radio:checked').val();
        // Cookie our user-supplied address
        storeAddress();
        getUserCoords(suppressFeedback);
    }

    function storeAddress() {
        var address = $form.find('input[name=address]').val(),
            zip = $form.find('input[name=zip]').val();

        Cookies.set('address', address).set('zip', zip);
    }

    function getUserCoords(suppressFeedback) {
        // Let's first check to see if the user has already run
        // a search on the same address (if so, no need to run again)
        var address = $form.find('input[name=address]').val(),
            zip = $form.find('input[name=zip]').val();
        if ((userAddress.address !== null) && (userAddress.address === address) &&
            (userAddress.zip !== null) && (userAddress.zip === zip) &&
            (userCoords.lat !== null) && (userCoords.lng !== null)) {
            // Use existing lat/lng data
            performSearch(userCoords.lat, userCoords.lng, userAddress.state);
        } else if ((address === '') || (zip === '')) {
            if (suppressFeedback !== true) {
                showMessage('Please enter an address and zip code.');
            }
            activateForm();
        } else {
            // Run a geocode lookup
            userAddress.address = address;
            userAddress.zip = zip;
            doGeoLookup(userAddress.address, userAddress.zip);
        }
    }

    function doGeoLookup(address, zip) {
        $.getJSON(
            'https://maps.googleapis.com/maps/api/geocode/json',
            {
                sensor: false,
                address: address + ',' + zip,
                key: GOOGLE_API_KEY_UNFILTERED
            }
        )
        .done(function(data, textStatus) {
            // console.log('geocode REQUEST status: ' + textStatus);
            // console.log('geocode RESULTS status: ' + data.status);
            if (data.status === 'OK') {
                userCoords.lat = data.results[0].geometry.location.lat;
                userCoords.lng = data.results[0].geometry.location.lng;
                userAddress.state = getStateFromResults(data.results[0].address_components);
                performSearch(userCoords.lat, userCoords.lng, userAddress.state);
            } else {
                showMessage('We\'re sorry, but we couldn\'t locate that address.');
                activateForm();
            }
        })
        .fail(function(data, textStatus) {
            showMessage('We\'re sorry, but we encountered an error.  Please try again later.');
            activateForm();
        });
    }

    /**
     * Our geocoding process will return detailed address components, in addition
     * to our lat/lng values.  Here, we extract the state value from the address,
     * to be used to reduce the number of location comparisons we'll need to
     * run later.
     * @param  {array} addressComponents    Array of address components returned from geocode request
     * @return {string|null}                Either our state value (2 char) or null
     */
    function getStateFromResults(addressComponents) {
        var state = null;
        for (var i = 0; i < addressComponents.length; i++) {
            var el = addressComponents[i];
            if (el.types[0] === 'administrative_area_level_1') {
                state = el.short_name.toLowerCase();
                break;
            }
        }
        return state;
    }

    function performSearch(lat, lng, state) {
        if (searchType === DELIVERY) {
            // do delivery search...
            deliverySearch(lat, lng, state);
        } else if (searchType === TAKEOUT) {
            // do takeout search...
            takeoutSearch(lat, lng, state);
        }
        // !!! TEMP !!!
        activateForm();
    }


    // DELIVERY SEARCH -----------------------------------------
    
    function deliverySearch(lat, lng, state) {
        // Grab locations that match the state, if state is available.
        // Note that this specification could be easily removed if 
        // restaurants are opened close to a state border.
        var $locs = null,
            userPoint = new google.maps.LatLng(lat, lng),
            selector = '.locations-list__data .does-delivery',
            $deliveryLoc = null;

        if (state !== null) {
            selector += '.state-' + state;
        }

        $locs = $(selector);

        $.each($locs, function(index, el) {
            var $loc = $(el),
                points = $loc.data('deliveryArea'),
                deliveryPoly = getPolygon(points);

            if (google.maps.geometry.poly.containsLocation(userPoint, deliveryPoly)) {
                // Match!
                $deliveryLoc = $loc;
                return false;
            }
        });

        if ($deliveryLoc !== null) {
            updateDeliveryList($deliveryLoc);
            renderDeliveryMap($deliveryLoc);
        } else {
            showMessage('We\'re sorry, but no stores deliver to that location.<br>Perhaps try a takeout search instead!');
        }
    }

    /**
     * Takes an array of 2 element arrays, where each 2 element array
     * represents a location vertex (ie. a lat and a lng value).  We 
     * then convert this location data into a Google polygon (for 
     * use in our delivery area search functionality)
     * @param  {array} points Array of 2 element arrays (location data)
     * @return {Polygon}        A Google Polygon object
     */
    function getPolygon(points) {
        var formattedPoints = [];

        $.each(points, function(index, el) {
            var latLng = {lat: el[0], lng: el[1]};
            formattedPoints.push(latLng);
        });

        return new google.maps.Polygon({paths: formattedPoints});
    }


    // TAKEOUT SEARCH -----------------------------------------

    function takeoutSearch(lat, lng, state) {
        // Let's start by zeroing out our displayed store count.  We use
        // this value when calculating the distance range of stores to
        // display at a time.
        displayedTakeoutCount = 0;

        // Let's also clear out our list of markers & dom elements.
        displayedTakeoutElements = [];

        // Grab locations that match the state, if state is available.
        // Note that this specification could be easily removed if 
        // restaurants are opened close to a state border.
        var selector = '.locations-list__data .does-takeout',
            origin = [{
                lat: parseFloat(lat), 
                lng: parseFloat(lng)
            }],
            $takeoutLocs = null,        // jQuery collection of store locations we test against
            destinations = [];          // Array of lat/lng objects passed to distance matrix

        if (state !== null) {
            selector += '.state-' + state;
        }

        $takeoutLocs = $(selector);

        if ($takeoutLocs.length === 0) {
            // This means that there are no stores in the user's state.  Don't 
            // even bother to try distance calculation.
            showMessage('We\'re sorry, but there are no stores in your area.');
            activateForm();
            return;
        }

        $.each($takeoutLocs, function(index, el) {
            var $loc = $(el);

            console.log('LOC: ', $loc.data('address'));

            destinations.push({
                lat: parseFloat($loc.data('lat')), 
                lng: parseFloat($loc.data('lng'))
            });
        });
        var distanceMatrix  = new google.maps.DistanceMatrixService();
        var distanceRequest = { 
            origins: origin, 
            destinations: destinations, 
            travelMode: google.maps.TravelMode.DRIVING, 
            unitSystem: google.maps.UnitSystem.IMPERIAL, 
            avoidHighways: false, 
            avoidTolls: false 
        };
        // console.time('distanceMatrix');
        distanceMatrix.getDistanceMatrix(distanceRequest, function(response, status) {
            // console.timeEnd('distanceMatrix');
            if (status !== google.maps.DistanceMatrixStatus.OK) {
                showMessage('We\'re sorry, but we encountered an error.  Please try again later.');
                activateForm();
            } else {
                var results = response.rows[0].elements;

                orderedTakeoutList = processTakoutResults(results, $takeoutLocs);
                updateTakeoutDisplay();
                if (displayedTakeoutCount > 0) {
                    // Only show the map if there are actual locations to show
                    renderTakeoutMap();
                }
            }
        });

    }

    /**
     * Here, we add our distance matrix results into our takeout location collection,
     * forming a new array of simplified objects (containing only the data we need).
     * We'll also sort the results into closest-first order to prepare for display. 
     * @param  {array} results       Array of 'row' data (dist/time) returned from matrix request
     * @param  {jQuery} $takeoutLocs Collection of store elements where we track store data
     * @return {jQuery}              Updated jQuery collection, ordered in closest-first order
     */
    function processTakoutResults(results, $takeoutLocs) {
        var locations = [];
        for (var i = 0; i < results.length; i++) {
            var $loc = $($takeoutLocs[i]),
                result = results[i];

            // Do a quick conversion of the 'value' property on our distance
            // elements to represent miles instead of meters (requesting 'Imperial'
            // units has no affect on this)
            result.distance.value = Math.round(result.distance.value / 1609 * 10) / 10; // To get to single decimal val
            locations.push({
                distance:   result.distance,
                duration:   result.duration,
                address:    $loc.data('address'),
                lat:        $loc.data('lat'),
                lng:        $loc.data('lng'),
                url:        $loc.data('takeoutUrl'),
                isClosed:   $loc.data('isClosed')
            });
        }
        // Sort location results, closest first
        locations.sort(function(a, b) {
            return a.distance.value - b.distance.value;
        });
        return locations;
    }


    function updateTakeoutDisplay() {
        // Step through our distance values and see if the resulting
        // store count (within each distance range) is different than
        // the current store count.  If it is, store the new store
        // count number.
        var storeCount = 0,         // Used to track number of stores within ranges
            newDisplayCount = 0,    // Once we've settled on a new display count, store it here
            rangeIndex = 0,         // Used to step through our possible distance ranges
            storeIndex = 0;         // Used to step through our collection of stores
            
        // NOTE: displayedTakeoutCount - stores number of stores CURRENTLY being displayed
        //       displayedTakeoutElements - stores references to displayed takeout dom elements & markers

        var distanceCheck = DISTANCE_RANGES[rangeIndex];

        while (storeIndex < orderedTakeoutList.length) {
            var store = orderedTakeoutList[storeIndex];
            if (store.distance.value <= distanceCheck) {
                // Means this store is within the current range -- increase the count
                storeCount++;
                // Let's also bump up our store index (need to check the next location)
                storeIndex++;
            } else {
                // No more (if any) stores within the current range.  Let's check to see if 
                // the store count is different than the currently displayed count.
                // If so, we're good -- we've found a new range (with additional
                // stores) to display.
                if ((newDisplayCount === 0) && (storeCount > displayedTakeoutCount)) {
                    // Assuming we don't already have a new display count established, 
                    // we store the new value here.  If we DO already have a new count
                    // set (and newDisplayCount != 0), it means we're just continuing
                    // through our cycle to see if a 'load more' button will be needed.
                    newDisplayCount = storeCount;
                } 

                // Let's bump up to the next range to continue testing
                rangeIndex++;
                if (rangeIndex >= DISTANCE_RANGES.length) {
                    // No ranges left to check...
                    // If, at this point, our store count is equal to the NEW display count,
                    // and given we've just run out of ranges to check against, we know that there
                    // are no more stores to display.  Hide the 'load more' button.
                    if (storeCount === newDisplayCount) {
                        $loadMore.hide();
                    }
                    break;
                }
                distanceCheck = DISTANCE_RANGES[rangeIndex]; 
            }
        }

        // If we've tested all locations, we need to perform an additional check here
        // to see if the storeCount value is greater than what's being displayed
        // (meaning there are stores still to display), but yet no newDisplayCount
        // value exists.  This would be the case if ALL stores fall within the 
        // new/largest range being tested.
        if ((newDisplayCount === 0) && (storeCount > displayedTakeoutCount)) {
            newDisplayCount = storeCount;
            $loadMore.hide();
        }

        // If our new display count is STILL 0 at this point, we have no 
        // stores to display.
        if (newDisplayCount === 0) {
            // Means there are no store locations within any range.
            showMessage('We\'re sorry, but there are no locations within range.');
            displayedTakeoutCount = 0;
            activateForm();
            return;
        }

        // Add the new locations
        for (var i = displayedTakeoutCount; i < newDisplayCount; i++) {
            var $mkup = $(getLocMarkup(orderedTakeoutList[i]));
            $mkup.hide();
            $locDisplay.append($mkup);
            $mkup.fadeIn();

            // Store a reference to the dom element.
            displayedTakeoutElements.push({
                domEl: $mkup
            });
        }

        // Update our displayedTakeoutCount value
        displayedTakeoutCount = newDisplayCount;
        console.log(storeCount, newDisplayCount);

        // Check whether a 'load more' button is needed (ie if there are more stores
        // within our allowed ranges than are currently being displayed)
        if (storeCount > newDisplayCount) {
            console.log('load more show');
            $loadMore.show();
        }

        
    }


    /**
     * Send a message string to the locations display area.  This should be user-friendly
     * messaging, meant to be read by the end-user.
     * @param  {string} text Description of the error or message.
     * @return {void}      
     */
    function showMessage(text) {
        var mkup = '<div class="locations-display__error">' + text + '</div>';
        $locDisplay.html(mkup);
    }

    /**
     * Clear out whatever content is in the location display area (will typically 
     * contain either location info or error/user messaging), along with the map
     * @return {void} 
     */
    function clearResults() {
        hideMap();
        my.map.clearMarkers();
        $locDisplay.html('');
        $loadMore.hide();
    }

    function updateDeliveryList($loc) {
        var data = {
                address:    $loc.data('address'),
                url:        $loc.data('deliveryUrl'),
                isClosed:   $loc.data('isClosed')
            },
            mkup = getLocMarkup(data);

        $locDisplay.html(mkup);
    }

    /**
     * Build markup structure for a location match.  This gets 
     * returned from this function, and will ultimately get 
     * injected into the page.
     * @param  {object} data Data object containing store data
     * @return {string}      Markup to build the location item on the screen
     */
    function getLocMarkup(data) {
        var mkup = '<div class="locations-display__item">';
        mkup += data.address;
        if (data.distance !== undefined) {
            mkup += ' (' + data.distance.text + ')';
        }
        mkup += '<br>';
        if (!data.isClosed) {
            mkup += '<a class="standard-button standard-button--thin standard-button--black standard-button--vertical-padding" href="' + data.url + '" target="_blank">Order</a>';
        } else {
            mkup += '(TEMPORARILY CLOSED)'
        }
        mkup += '</div>';
        return mkup;
    }


    // ---------------------------------------------------------
    // MAP
    // ---------------------------------------------------------

    function renderDeliveryMap($loc) {
        // console.log('rendering map: ', $loc.data('lat'), $loc.data('lng'));
        var latLng = my.map.getPoint($loc.data('lat'), $loc.data('lng')),
            title = $loc.data('address'),
            winText = '<div style="padding-bottom:.5em">' + title + '</div>',
            marker = null;

        if (!$loc.data('isClosed')) {
            // If the location is not closed, let's also add an ORDER button
            winText += '<a href="' + $loc.data('deliveryUrl') + '" target="_blank"><strong>ORDER</strong></a>'
        } else {
            winText += '<strong>TEMPORARILY CLOSED</strong>';
        }
        
        my.map.getMap(MAP_ID, latLng);

        marker = my.map.addMarker(latLng, title, winText);

        // show the map
        showMap();
    }

    function renderTakeoutMap() {
        // Start out by initializing the map (required in order for
        // markers to be placed)
        var userLatLng = my.map.getPoint(userCoords.lat, userCoords.lng);
        my.map.getMap(MAP_ID, userLatLng);  // Start out centered on user

        // Add a marker for our user location
        var userTitle = userAddress.address,
            markerPath = '/assets/img/user-location.png',
            userMarker = my.map.addMarker(userLatLng, userTitle, null, markerPath);

        // Cycle through our list of displayed stores, as contained
        // within our displayedTakeoutElements array.  If an element
        // does not yet have a marker associated with it, add one.
        for (var i = 0; i < displayedTakeoutElements.length; i++) {
            var el = displayedTakeoutElements[i];
            if (!el.hasOwnProperty('marker')) {
                // This list entry does not yet have a marker created for
                // it.  Let's make it now, using lat/lng data from the
                // corresponding item in our orderedTakeoutList.
                var storeData = orderedTakeoutList[i];
                /*
                    Data available on the storeData item:
                    distance, duration, address, lat, lng, url
                 */
                var latLng = my.map.getPoint(storeData.lat, storeData.lng),
                    title = storeData.address;
                    
                var directionsUrl = 'https://www.google.com/maps/dir/?api=1&origin='+ userCoords.lat + ',' + userCoords.lng;
                directionsUrl += '&destination=' + storeData.lat + ',' + storeData.lng;

                var winText = '<div style="padding-bottom:.5em">' + title + '</div>';
                if (!storeData.isClosed) {
                    // If the location is not closed, let's also add an ORDER button
                    winText += '<a href="' + storeData.url + '" target="_blank"><strong>ORDER</strong></a> | <a href="' + directionsUrl + '" target="_blank"><strong>DIRECTIONS</strong></a>';
                } else {
                    winText += '<strong>TEMPORARILY CLOSED</strong>';
                }

                var marker = my.map.addMarker(latLng, title, winText);

                // Add the marker to our displayed element list
                el.marker = marker;
            }
        }

        // Fit the map to the markers
        my.map.fitMapToMarkers();
        
        // show the map
        showMap();
    }

    function hideMap() {
        $mapDisplay.css({ opacity: 0, zoom: 0 });
    }

    function showMap() {
        $mapDisplay.css({ opacity: 1, zoom: 1 });
    }



    function initScreenHeight() {
        // Make sure the page body is tall enough to keep the footer 
        // initially out of sight
        $content = $('.order-online__wrap');

        $(window).resize(checkScreenSize);

        checkScreenSize();
    }

    function checkScreenSize() {
        var minHeight = $(window).height() - parseInt($content.css('marginTop')) + 10;
        $content.css('minHeight', minHeight);
    }
    


    exports.init = function() {
        initForm();
        hideMap();
        initScreenHeight();

        // As a final step, dispatch notification that the body size has
        // changed.  We need this for adjusting other size-related elements
        // (eg. visibility of the sidebar 'aux' element)
        var evt = $.Event( "bodySizeChange" );
        $('body').trigger(evt);
    };

    return exports;

})(Otto, jQuery);